import { Component } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { ToastService } from '../core/toast.service';
import { ClienteapiService } from '../dao/api_cliente.service';
import { UnidadeApiService } from '../dao/api_unidade.service';
import { GlobalService } from '../dao/global.service';
import { Unidade } from '../model/unidade';

@Component({
  selector: 'app-home',
  templateUrl: 'home.page.html',
  styleUrls: ['home.page.scss'],
})
export class HomePage {

  Webmode;
  unidades: Unidade[] = [];
  Usuario: string;
  data = new Date();
  plano;
  dominio;
  tema;
  comandaMesa;
  labelEncomenda
  modulos;
  labelModulos;
  impressao_tipo;
  impressao_tamanho;
  planoString;

  unidade: Unidade;

  constructor(public global: GlobalService,
    private apicliente: ClienteapiService,
    private toast: ToastService,
    private alertController: AlertController,
    private apiUnidade: UnidadeApiService) { }

  // tslint:disable-next-line: use-lifecycle-interface
  async ngOnInit() {
    this.impressao_tipo =
    this.impressao_tamanho =
    this.comandaMesa = this.global.comandaMesa;
    this.labelEncomenda = this.global.labelEncomenda
    this.loadUnidade();
    this.data = new Date();
    this.getModulos();
    this.Webmode = this.global.debugMode;
    this.criaSession();
    this.Usuario = this.global.nome;
    this.plano = this.global.plano;

  }

  async ionViewDidEnter() {
    this.comandaMesa = this.global.comandaMesa;
    this.labelEncomenda = this.global.labelEncomenda
    this.getModulos();
    this.Webmode = this.global.debugMode;
  }

  async getModulos() {
    this.modulos = await this.apiUnidade.getMenu();
    this.comandaMesa = this.global.comandaMesa;
    this.labelEncomenda = this.global.labelEncomenda

    // tslint:disable-next-line: prefer-for-of
    for (let index = 0; index < this.modulos.length; index++) {
      const element = this.modulos[index];

      if (element.routerlink === '/submenu/6') {
        element.label = this.comandaMesa + 's';
      }

      if (element.routerlink === '/submenu/8') {
        element.label = this.labelEncomenda + 's';
      }

      if (!(element.planos.includes(this.plano))) {
        element.liberado = 0;
      } else {
        element.liberado = 1;
      }
    }
  }

  async loadUnidade() {
    this.unidade = await this.apiUnidade.getAtual();
    this.tema = this.unidade.tema;
  }

  goToLink(url: string){
    console.log("teste");
    window.open(url, "_blank");
}

  async avisoFunc() {
    const alert = await this.alertController.create({
      header: 'Aviso',
      subHeader: 'Importante',
      message: 'Esta funcionalidade não está disponível no plano atual. <br> Para mais informações, entre em contato conosco. <a href="https://api.whatsapp.com/send?phone=5511963697271">clicando aqui</a> pelo WhatsApp (11) 96369-7271',
      buttons: ['OK']
    });

    await alert.present();
  }

  async limparSessao(){
    console.log("Entrou na Sess");
    const keysToRemove = [
      "user",
      "senha_adm",
      "plano",
      "pass",
      "nome",
      "loja",
      "labelEncomenda",
      "impressao_tipo",
      "impressao_tamanho",
      "comandaMesa",
      "authToken"
    ];
    
    keysToRemove.forEach(key => localStorage.removeItem(key));

    window.location.href = "";
  }

  async criaSession() {
    try {

      this.apicliente.verificaLogin(this.global.user, this.global.pass).then(res => {
        this.unidades = res;
        this.dominio = this.unidades[0].dominio;
        //this.global.loja = this.dominio;
        //this.global.senha_adm = this.unidades[0].senha_adm; 

        localStorage.setItem('loja', this.dominio);
        localStorage.setItem('senha_adm', this.unidades[0].senha_adm);
        
        if(this.global.plano == "0" || this.global.plano == "0"){
          this.planoString = "SMART"
        }

        if(this.global.plano == "1" || this.global.plano == "1"){
          this.planoString = "ADVANCED"
        }

        if(this.global.plano == "2" || this.global.plano == "2"){
          this.planoString = "PREMIUM"
        }

      }).catch(async err => {
        console.log('err', err);
        this.toast.showError('Usuário ou senha incorretos');
      });

    } catch (error) {
      console.log(error);
      this.toast.showError('Ocorreu um erro');
    }

  }

}
